module.exports = __webpack_public_path__ + "img/gb-wls.85f8b842.svg";